import { withInstall } from '@ll-plus/utils'

import AdvancedFiltering from './src/advanced-filtering.vue'
import AdvancedFilteringParams from './src/components/advanced-filtering-params.vue'
import AdvancedFilteringTags from './src/components/advanced-filtering-tags.vue'

export const LlAdvancedFiltering = withInstall(AdvancedFiltering)
export const LlAdvancedFilteringParams = withInstall(AdvancedFilteringParams)
export const LlAdvancedFilteringTags = withInstall(AdvancedFilteringTags)

export * from './src/advanced-filtering'

declare module 'vue' {
  export interface GlobalComponents {
    LlAdvancedFiltering: typeof AdvancedFiltering
    LlAdvancedFilteringParams: typeof AdvancedFilteringParams
    LlAdvancedFilteringTags: typeof AdvancedFilteringTags
  }
}
